// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PageTitle_wrapper__3X2tz","title":"PageTitle_title__smy8p"};